export enum TableId {
    Devices = 'devices',
    DeviceComponents = 'deviceComponents',
}